
<svg :width="width" :height="height" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.47487 5.38909L0.292893 2.20711C-0.0976311 1.81658 -0.0976311 1.18342 0.292893 0.792893C0.683417 0.402369 1.31658 0.402369 1.70711 0.792893L4.88909 3.97487L8.07107 0.792893C8.46159 0.402369 9.09476 0.402369 9.48528 0.792893C9.87581 1.18342 9.87581 1.81658 9.48528 2.20711L6.3033 5.38909L9.48528 8.57107C9.8758 8.96159 9.8758 9.59476 9.48528 9.98528C9.09476 10.3758 8.46159 10.3758 8.07107 9.98528L4.88909 6.8033L1.70711 9.98528C1.31658 10.3758 0.683418 10.3758 0.292893 9.98528C-0.0976309 9.59476 -0.0976309 8.96159 0.292893 8.57107L3.47487 5.38909Z"
    :fill="color"
  />
</svg>
